<template>
  <div id="register-result">
    <div class="success-icon-wrapper">
      <img :src="successImage" alt="" />
    </div>
    <Zpert v-if="$route.query.source === 'ZPERT'" />
    <BimMake v-else-if="bimmakes.includes($route.query.source)" :type="$route.query.source" />
    <Animation  v-else-if="$route.query.source === 'GPS'"/>

    <div class="close" v-if="$route.query.source == 'ZPERT'" @click="windowClose">关闭</div>
  </div>
</template>

<script>
import Zpert from "./Zpert.vue";
import BimMake from "./BimMake.vue";
import Animation from "./Animation.vue";
import successImage from "@/assets/images/success.png";
import "./style.scss";
export default {
  data() {
    return {
        successImage,
        bimmakes: ['BIMMAKE2520', 'BIMMAKE3330', 'BIMMAKE3331']
    };
  },
  components: {
    Zpert,
    BimMake,
    Animation,
  },
  methods: {
    windowClose() {
      window.location.href = "about:blank";
      window.close();
      // window.open('about:blank', '_top').close()
    },
  },
};
</script>

<style scoped lang="scss">
#register-result {
  background-image: url('../../assets/images/bimback.png');
  background-repeat: no-repeat;
  background-size:100% 100%;
  height: 100vh;
  // padding-top: 56px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .success-icon-wrapper {
    width: 234px;
    height: 139.87px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .close {
    background-color: #438afe;
    margin-top: 53px;
    width: 154px;
    height: 46px;
    border-radius: 29px;
    line-height: 46px;
    text-align: center;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #fff;
    cursor: pointer;
  }
}
</style>
